enum PaymentMethodType {
  Card = 'CARD',
  Cash = 'CASH',
  Qr = 'QR',
  CheckingAccount = 'CHECKINGACCOUNT',
  Split = 'SPLIT'
}

export default PaymentMethodType;
